import { render, staticRenderFns } from "./CoursesPage.vue?vue&type=template&id=6a782e30&"
import script from "./CoursesPage.vue?vue&type=script&lang=js&"
export * from "./CoursesPage.vue?vue&type=script&lang=js&"
import style0 from "./CoursesPage.vue?vue&type=style&index=0&id=6a782e30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports